export class ApplicationTimeoutError extends Error {
    elapsed = 0;

    constructor(elapsed: number, message?: string) {
        super(message);

        this.elapsed = elapsed;
    }
}
